import {AddBackground, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalImageBackground} from "./PortalImageBackground";
import {PortalColorBackground} from "./PortalColorBackground";

export enum BackgroundMode {
	COLOR = "color",
	IMAGE = "image"
}

export class PortalAddBackground extends AddBackground implements Parameter {
	public mode?: BackgroundMode;

	constructor(data: any) {
		super(data);

		this.mode = FunctionHelper.exists(data?.mode) ? data.mode : BackgroundMode.COLOR;
		this.imageBackground = PortalImageBackground.fromJson(data?.imageBackground);
		this.colorBackground = PortalColorBackground.fromJson(data?.colorBackground);
	}

	public static getModeDefault(): BackgroundMode {
		return BackgroundMode.COLOR;
	}

	public static fromJson(data: any): PortalAddBackground {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalAddBackground(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'mode': this.mode,
		};
	}

	public clone(): PortalAddBackground {
		return PortalAddBackground.fromJson(this.toJson());
	}
}